import React, { FC, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import SelectField from '@buyside/components/presentation/Fields/selectField';

const EmployerField: FC<{
  currentEmployers: {
    id: string;
    canExtendCapIntroAccess: boolean;
    name: string;
    hasFundProfile: boolean;
  }[];
  isDraft: boolean;
}> = ({ currentEmployers, isDraft }) => {
  const { setValue } = useFormContext();

  const currentEmployerOptions = useMemo(
    () => [
      { label: 'None', value: '' },
      ...currentEmployers.map(({ id, name }) => ({
        label: name,
        value: id
      }))
    ],
    [currentEmployers]
  );

  const onChangeCallback = useCallback(
    (employerId: string) => {
      const selectedEmployerHasFundProfile =
        employerId &&
        currentEmployers.some(({ id, hasFundProfile }) => id === employerId && hasFundProfile);

      if (!selectedEmployerHasFundProfile) setValue('fundProfileDisplay', false);
      if (!employerId) setValue('positionDisclaimerFund', false);
    },
    [currentEmployers, setValue]
  );

  const generateHelperElement = useCallback(() => {
    const employersEligibleForCapIntroExtension = currentEmployers.filter(
      ({ canExtendCapIntroAccess }) => canExtendCapIntroAccess
    );

    if (employersEligibleForCapIntroExtension.length && isDraft)
      return (
        <small>
          Associate this research with your fund (
          {employersEligibleForCapIntroExtension.map(({ name }) => name).join(', ')}) to reactivate
          your fund profile and access the Cap Intro platform.
        </small>
      );

    return null;
  }, [currentEmployers, isDraft]);

  return (
    <SelectField
      generateHelperElement={generateHelperElement}
      label="Associated Fund"
      name="employerId"
      onChangeCallback={onChangeCallback}
      options={currentEmployerOptions}
    />
  );
};

export default EmployerField;
